type Step = 'auth_status' | 'auth_request' | 'agent_confirm' | 'agent_preview' | 'business';
type ErrorClass = 'fetch' | 'routing' | 'json_parse' | 'envelope' | 'http_status';
type Diagnostic = {step: Step; error_class: ErrorClass; status: number | null; at: number};
const key = 'account-connection-diagnostics-v1';
function load(): Diagnostic[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw || raw.length > 2048) return [];
    const value: unknown = JSON.parse(raw);
    if (!Array.isArray(value) || value.length > 3) return [];
    if (!value.every(row => row && typeof row === 'object'
      && Object.keys(row).sort().join(',') === 'at,error_class,status,step'
      && ['auth_status','auth_request','agent_confirm','agent_preview','business'].includes(row.step)
      && ['fetch','routing','json_parse','envelope','http_status'].includes(row.error_class)
      && (row.status === null || Number.isInteger(row.status) && row.status >= 100 && row.status <= 599)
      && Number.isInteger(row.at) && row.at >= 0 && row.at <= 4102444800)) return [];
    return value as Diagnostic[];
  } catch { return []; }
}
let rows: Diagnostic[] = load();

export function rememberConnection(step: Step, errorClass: ErrorClass, status: number | null = null) {
  rows = [...rows, {step, error_class: errorClass, status, at: Math.floor(Date.now() / 1000)}].slice(-3);
  try { localStorage.setItem(key, JSON.stringify(rows)); } catch { /* Keep memory diagnostics when storage is unavailable. */ }
}
export function connectionSnapshot() { return rows.map(row => ({...row})); }
export async function feedbackConnectionSnapshot() {
  const snapshot = connectionSnapshot();
  if (!snapshot.length) return [];
  try {
    const response = await fetch('/api/health', {cache: 'no-store', signal: AbortSignal.timeout(2000)});
    if (!response.ok) return [];
    const value = await response.json();
    // Cloud pages also serve older clients whose feedback input rejects new fields.
    const version = typeof value?.client_version === 'string' && /^(\d+)\.(\d+)\.(\d+)$/.exec(value.client_version);
    if (!version) return [];
    const [major, minor, patch] = version.slice(1).map(Number);
    return major > 2 || major === 2 && (minor > 1 || minor === 1 && patch >= 127) ? snapshot : [];
  } catch { return []; }
}
export function clearConnectionDiagnostics() {
  rows = [];
  try { localStorage.removeItem(key); } catch { /* Storage can be unavailable in a locked-down browser. */ }
}
export function businessStep(path: string): Step {
  return path === '/agent-runs/confirm' ? 'agent_confirm' : path.startsWith('/agent-runs/preview') ? 'agent_preview' : 'business';
}
